exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errors[data-v-342ded60]{padding:1em 0 2em}.errors .error[data-v-342ded60]{color:red;font-weight:700}.errors a[data-v-342ded60]{padding:0}", ""]);

// exports
